module.exports = __webpack_public_path__ + "img/IMG_9697_1.f63ea1f4.jpeg";